import { PropsWithChildren } from 'react';
import { Tooltip } from '@ds';
import { ReservationData } from '@/api/apis/resources';
import { getGroupedReservationsOnCase } from '@/utils/helpers';

export const getAssignBtnTooltipContent = (
  isReservedOnCase: boolean,
  isLogistics: boolean,
  reservations: ReservationData[],
) => {
  if (isReservedOnCase && !isLogistics) return 'Resource is used in logistics and should be managed from there.';
  const [, current] = getGroupedReservationsOnCase(reservations);
  if (current.length) {
    return (
      <span>
        On case:
        <span className="font-semibold"> {current[0].caseName}</span>
      </span>
    );
  }
  return '';
};

type TooltipProps = {
  isLogistics: boolean;
  isReservedOnCase: boolean;
  reservations: ReservationData[];
};

export const DeviceReserveButtonTooltip = ({
  isLogistics,
  isReservedOnCase,
  reservations,
  children,
}: TooltipProps & PropsWithChildren) => {
  const tooltipContent = getAssignBtnTooltipContent(isReservedOnCase, isLogistics, reservations);
  return (
    <Tooltip showArrow content={tooltipContent} isDisabled={!tooltipContent}>
      {children}
    </Tooltip>
  );
};
